import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CompletionBehaviorTemplate } from "../../../entities/completionBehaviorTemplate/completionBehaviorTemplate";
import { RefetchCoordinator } from "../../refetch-coordinator/refetch-coordinator.service";
import { ToastService } from "../../toast/toast.service";
import { CompletionBehavior, HasCommands, Reloadable } from "../command.service";

@Injectable({
    providedIn: 'root'
  })
export class RedirectCompletionBehavior implements CompletionBehavior {

    constructor(
        private toastService: ToastService,
        private router: Router,
        readonly refetchCoordinator: RefetchCoordinator
    ) { }

    executeCompletionBehavior(hasCommands: HasCommands, completionBehaviorTemplate: CompletionBehaviorTemplate, reloadable?: Reloadable) {

        // a redirect is currently only followed aber an deletion. so we trigger
        // here the reload of affected lists
        if(hasCommands?.getEntityType()){
            this.refetchCoordinator.emit({ entityType: hasCommands.getEntityType() });
        }

        const showToast = completionBehaviorTemplate?.settings?.showToast;
        const toastMessage = completionBehaviorTemplate?.settings?.toastMessage;
        const destination = completionBehaviorTemplate?.settings?.destination;

        if(showToast && toastMessage){
            this.toastService.addToastWithMessage(toastMessage);
        }

        if(destination == 'collection' && hasCommands.getCollectionRoute()){
            const collectionRoute = hasCommands.getCollectionRoute();
            const currentUrl = this.router.url;
            // if the collection route is the same as the current URL, we reload the page
            if(currentUrl === collectionRoute){
                if(reloadable){
                    reloadable.reload();
                }
            } else {
                 this.router.navigate([collectionRoute]);
            }

        }

    }

}
